import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
    TYPE_RESULT,
    TYPE_COMMENT,
    TYPE_EMAIL,
    RESULT_TYPE_SUFFIX,
    RESULT_TYPE_STATUS,
    RESULT_TYPE_PROCESS_STATUS,
    RESULT_TYPE_AUTHOR_DECISION,
    PROCESS_STATUSES,
    TYPE_DOWNLOAD,
    TYPE_OVERDUE, TYPE_REVIEW_COMPLETED,
} from 'Constants';
import { getAttachmentTitle } from 'Utils';

/**
 * @param {object} activity
 */
export function getActivityParams(activity) {
    let title, color, body;
    switch (activity.activityType) {
        case TYPE_RESULT:
            title = <FormattedMessage id={`types.activity.${RESULT_TYPE_SUFFIX[activity.type]}`}/>;
            color = (() => {
                switch (activity.type) {
                    case RESULT_TYPE_STATUS:
                        return 'success';
                    case RESULT_TYPE_PROCESS_STATUS:
                        return 'rose';
                    case RESULT_TYPE_AUTHOR_DECISION:
                        return 'primary';
                }
            })();
            body = (() => {
                switch (activity.type) {
                    case RESULT_TYPE_STATUS:
                        return <span>To phase: <b>{activity.status.status}</b></span>;
                    case RESULT_TYPE_PROCESS_STATUS:
                        return <span>To status: <b>{PROCESS_STATUSES[activity.value]}</b></span>;
                    case RESULT_TYPE_AUTHOR_DECISION:
                        return <b><FormattedMessage id={activity.value ? 'submission.decision.agreed' : 'submission.decision.declined'}/></b>;
                }
            })();
            break;

        case TYPE_COMMENT:
            title = <FormattedMessage id={'types.activity.comment'}/>;
            color = 'info';
            body = activity.comment;
            break;

        case TYPE_EMAIL:
            title = <FormattedMessage id={'types.activity.email'}/>;
            color = 'info';
            body = (
                <div>
                    <p>Subject: <b>{ activity.subject }</b></p>
                    <p>From: <b>{ activity.from }</b></p>
                    <p>To: <b>{ activity.to }</b></p>
                </div>
            );
            break;

        case TYPE_DOWNLOAD:
            title = <FormattedMessage id={'types.activity.download'}/>;
            color = 'info';
            body = getAttachmentTitle(activity.attachment);
            break;

        case TYPE_OVERDUE:
            title = <FormattedMessage id={'types.activity.overdue'}/>;
            color = 'danger';
            break;

        case TYPE_REVIEW_COMPLETED:
            title = <FormattedMessage id={'types.activity.review_completed'}/>;
            color = 'warning';
            body = <span>Review round: <b>#{ activity.round.round }</b></span>;
            break;
    }

    return {title, color, body};
}



// WEBPACK FOOTER //
// ./src/utils/getActivityParams.js